/**
 * The single brand gradient recipe (135°, three stops). Every CTA/panel
 * gradient in the estate derives from this — never hand-roll the stops.
 */
export const brandGradient = (c: { light: string; main: string; dark: string }): string =>
  `linear-gradient(135deg, ${c.light} 0%, ${c.main} 50%, ${c.dark} 100%)`;

/** Horizontal two-stop variant used by progress indicators. */
export const progressGradient = (from: string, to: string): string =>
  `linear-gradient(90deg, ${from}, ${to})`;
